import { render, staticRenderFns } from "./ZiliaoData.vue?vue&type=template&id=646c1436&scoped=true&"
import script from "./ZiliaoData.vue?vue&type=script&lang=js&"
export * from "./ZiliaoData.vue?vue&type=script&lang=js&"
import style0 from "./ZiliaoData.vue?vue&type=style&index=0&id=646c1436&prod&lang=less&scoped=true&"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c1436",
  null
  
)

export default component.exports